import React from 'react';
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import { API_ENDPOINT } from '../components/Core/Grid/gridConstants';

/**
 * "Ver documento" do grid de contratos: o HTML congelado da versão atual, num
 * iframe.
 *
 * Não é a tela de posicionamento de assinatura, que depende do assinador e vem
 * depois. Quando vier, o padrão é o `DocumentPreviewModal`: barra lateral de 280px
 * com os campos e o iframe ao lado.
 */
export default function ContratoDocumentoViewer(props: any) {
    const contrato = props.data || {};
    const versaoAtual = Number(contrato.versao_atual) || 0;
    const url = `${API_ENDPOINT}/contrato-instalador.php?id=${contrato.id}&t=${Date.now()}`;

    return (
        <>
            <WindowBody noPadding>
                {versaoAtual < 1 ? (
                    <div style={{ padding: 20 }}>
                        <div className="alert alert-warning" style={{ margin: 0 }}>
                            Este contrato ainda não tem versão gerada. Use <b>Gerar versão</b> no grid.
                        </div>
                    </div>
                ) : (
                    <iframe
                        src={url}
                        style={{ width: '100%', height: '100%', border: 'none', background: '#f5f5f5' }}
                        title={`Contrato ${contrato.id}`}
                    />
                )}
            </WindowBody>
            <WindowFooter>
                <UiButton variant="secondary" type="button" onClick={props.triggerClose}>Fechar</UiButton>
                {versaoAtual >= 1 && (
                    <UiButton variant="primary" type="button" onClick={() => window.open(url, '_blank')}>
                        Abrir em nova aba
                    </UiButton>
                )}
            </WindowFooter>
        </>
    );
}
